export default __webpack_public_path__ + "static/media/alavancar.277466be.svg";